import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const FolderFileIcon = createSvgIcon(
  <g className="cd-folder-icon">
    <path
      d="M8 15.8c0-1.9 1.5-3.4 3.4-3.4h16.4c.9 0 1.8.4 2.3 1.2l2.1 3.1H52c2.3 0 4.2 1.9 4.2 4.2v2.4H8V15.8z"
      fill="var(--cd-folder-tab, #e07a1f)"
    />
    <path
      d="M6.4 23.2c0-2.5 2-4.5 4.5-4.5h42.2c2.5 0 4.5 2 4.5 4.5v24.6c0 2.5-2 4.5-4.5 4.5H10.9c-2.5 0-4.5-2-4.5-4.5V23.2z"
      fill="var(--cd-folder, #ff5e1f)"
    />
    <path
      d="M11 20.2h41.6c1.3 0 2.5.6 3.3 1.6-.7-1.8-2.5-3-4.5-3H12.2c-1.9 0-3.6 1.1-4.4 2.7.8-.8 2-1.3 3.2-1.3z"
      fill="#ffffff"
      opacity="0.22"
    />
  </g>,
  'FolderFileIcon',
);
